module.exports = __webpack_public_path__ + "static/media/hat-winter.ec23cbaf.svg";